module.exports = __webpack_public_path__ + "img/p64-huaian-2006.9a8b4bca.jpg";